import { createStyle } from '@gluestack-style/react';

export const AlertText = createStyle({
  flex: 1,
});
